<template>
  <div class="wrapper">
    <hearder :style="style"></hearder>
    <div class="main-container">
      <div class="app-main">
        <div class="app-content">
          <router-view :key="key" />
        </div>
      </div>
    </div>
    <footer-index></footer-index>
  </div>
</template>
<script>
import Hearder from './components/hearder'
import FooterIndex from './components/footer'

export default {
  name: 'Layout',
  components: { Hearder, FooterIndex },
  data() {
    return {
      style: {
        backgroundColor: ''
      }
    }
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.$nextTick(() => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        let element = document.querySelector('.home_bg')
        if (!element) return
        let offsetHeight = element.offsetHeight
        if (scrollTop >= offsetHeight - 80) {
          this.style.backgroundColor = `rgba(255, 255, 255, 1)`
        } else {
          this.style.backgroundColor = `rgba(255, 255, 255, 0.7)`
        }
      })
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
.main-container {
  min-height: calc(100vh - 413px);
  background-color: #ffffff;
}
.app-main {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue